export default function React_ES6_Destructuring() {
  return (
    <div>
      <h1>React_ES6_Destructuring Component</h1>
      <p>This is the React_ES6_Destructuring tutorial page.</p>
    </div>
  );
}
